import React from "react";
import { useTranslation } from "react-i18next";

const formatDate = (value, language) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat(language, {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
};

const statusConfig = {
  local: { label: "sensor_environment_local", variant: "success" },
  last_good: { label: "sensor_environment_last_good", variant: "info" },
  external_station: { label: "sensor_environment_station", variant: "warning" },
  external_model: { label: "sensor_environment_model", variant: "warning" },
  unavailable: { label: "sensor_environment_unavailable", variant: "danger" },
};

export default function SensorEnvironmentStatus({ environment }) {
  const { t, i18n } = useTranslation();
  if (!environment) return null;

  const config = statusConfig[environment.status] || statusConfig.unavailable;
  const measuredAt = formatDate(environment.observedAt, i18n.language);
  const lastGoodAt = formatDate(environment.lastGoodAt, i18n.language);
  const stationDistance = Number(environment.station?.distanceMeters);

  return (
    <div
      className={`alert alert-${config.variant} py-2 px-3 mb-3`}
      role="status"
      style={{ fontSize: "0.85rem" }}
    >
      <strong>{t(config.label)}</strong>
      {environment.rawInvalid && (
        <span className="ms-2">— {t("sensor_environment_bme_fault")}</span>
      )}
      {environment.station?.name && (
        <span className="ms-2">
          · {environment.station.name}
          {Number.isFinite(stationDistance)
            ? ` (${(stationDistance / 1000).toFixed(1)} km)`
            : ""}
        </span>
      )}
      {environment.status === "last_good" && lastGoodAt && (
        <span className="ms-2">· {t("sensor_environment_measured_at")} {lastGoodAt}</span>
      )}
      {environment.status === "external_station" && measuredAt && (
        <span className="ms-2">· {t("sensor_environment_measured_at")} {measuredAt}</span>
      )}
    </div>
  );
}
